define('src/plugins/mustache.extension',[
    // Libs
    'underscore', 'backbone', 'utils', 'mustache', 'moment',
    'services/i18n',
], function(_, Backbone, U, Mustache, moment, i18n) {

    var cachedContext;

    /**
     * Extends Mustache object with personalised functions.
     */
    var MustacheExtension = {

        /**
         * Extends the passed context object with default utility functions to
         * use inside a mustache template.
         *
         * @param  {Object} context - the data to pass to the template.
         * @param  {String} namespace - to use with the translatation {{#t}} function.
         * @return {Object} Augmented context object with utility function for the template.
         */
        getContext: function(context, namespace) {
            // return cached context instead of re-instanciating the object.
            if (arguments.length === 0 && cachedContext) {
                return cachedContext;
            }

            return _.extend({}, {

                /**
                 * Translation function. {{#t}}translate this text{{/t}}
                 * @return {string} translated content
                 */
                t: function() {
                    return function(text, render) {
                        if (namespace) return i18n.t(render(text), { ns: namespace });
                        return i18n.t(render(text));
                    };
                },
                relative: function() {
                    return function(text, render) {
                        return render(Backbone.history.relative(text));
                    };
                },

                /**
                 * {{#today}}YYYY/MM/DD{{/today}}
                 * @return {string} formatted today's date
                 */
                today: function() {
                    return function(text, render) {
                        return render(moment().format(text));
                    };
                },
            }, context);
        }
    };

    _.extend(Mustache, MustacheExtension);

    cachedContext = Mustache.getContext();

    return Mustache;

});

